import type { ComponentProps } from 'react';
import { type IconName, icons } from '../icons';

export type IconProperties = {
  icon: IconName;
} & Partial<IconComponentProperties>;

type IconComponentProperties = ComponentProps<(typeof icons)[IconName]>;

const Icon = ({ icon, ...defaultProperties }: IconProperties) => {
  const IconComponent = icons[icon];

  return <IconComponent {...defaultProperties} />;
};

export default Icon;
